module.exports = __webpack_public_path__ + "static/media/shopping.83513b10.svg";